import { useEffect, useMemo, useRef, useState } from 'react';

import { CardType } from 'components/Card';

import { getQueryString } from 'utils/browser';
import { stringToCategoryTag } from 'utils/stringToCategoryTag';
import { useQueryParams } from 'hooks/useQueryParams';

import { FILTER_TAG_QUERY } from './constans';
import getFiltered from './getFiltered';
import { ChoiceType, InitialCategoriesType, UseFiltersType } from './model.d';

export const useFilters: UseFiltersType = (
  items: CardType[],
  initialCategories: InitialCategoriesType,
  choiceType?: ChoiceType
) => {
  const firstUpdate = useRef(true);

  const [, setSearchParam, location] = useQueryParams({ key: FILTER_TAG_QUERY });

  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [sortedItems, setSortedItems] = useState<CardType[]>(items);
  const [allTags, setAllTags] = useState<string[]>([]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      setSelectedCategories([initialCategories]);
    }
  }, [initialCategories]);

  const handleSelectedCategories = (tagName: string) => {
    if (choiceType === ChoiceType.SINGLE) {
      if (selectedCategories.includes(stringToCategoryTag(tagName))) {
        setSelectedCategories([]);
      } else {
        setSelectedCategories([stringToCategoryTag(tagName)]);
      }
    } else if (selectedCategories.includes(stringToCategoryTag(tagName))) {
      setSelectedCategories(
        selectedCategories.filter(
          (tag) => stringToCategoryTag(tag) !== stringToCategoryTag(tagName)
        )
      );
    } else {
      setSelectedCategories([...selectedCategories, stringToCategoryTag(tagName)]);
    }
  };

  const filteredItems = useMemo(
    () => getFiltered(items, selectedCategories),
    [items, selectedCategories]
  );

  useEffect(() => {
    setSortedItems(filteredItems.items);
    setAllTags(filteredItems.allArticlesTags);
  }, [filteredItems]);

  useEffect(() => {
    setSearchParam(selectedCategories?.join(' '));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategories]);

  useEffect(() => {
    const urlCategoryQuery = getQueryString(FILTER_TAG_QUERY);
    if (urlCategoryQuery === null) return;

    setSelectedCategories(urlCategoryQuery.split(' '));
  }, [location]);

  return { selectedCategories, sortedItems, allTags, handleSelectedCategories };
};
